import BlogMidCTA from "../../../../src/components/BlogMidCTA";
import paneresize from "../../../../assets/videos/pane-resize.mp4";
import * as React from 'react';
export default {
  BlogMidCTA,
  paneresize,
  React
};